import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SelectOrigoCodeService {
  public codeSelected$ = new Subject<string>();
}
